// ------------------------------------------------------------------------------
//  Copyright (c) 2017-present, RobotlegsJS. All Rights Reserved.
//
//  NOTICE: You are permitted to use, modify, and distribute this file
//  in accordance with the terms of the license agreement accompanying it.
// ------------------------------------------------------------------------------

import { IExtension } from "./IExtension";

/**
 * A bundle installs a set of Extensions and Configurations into a Context
 */
export interface IBundle extends IExtension {}
